/**
 * エラーメッセージ情報
 */
export class ErrorInfo {
	// private変数 --------------------------------------------------------
	private m_Message: string = null; // id
	// --------------------------------------------------------------------

	// プロパティ --------------------------------------------------------------------
	/** id */
	public get message(): string { return this.m_Message; } 
	public set message(message: string) { this.m_Message = message; }
	// --------------------------------------------------------------------

	// コンストラクタ --------------------------------------------------------
	constructor() { }
	// ----------------------------------------------------------------------
}